<template>
  <div>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <h4  v-if="showAddressAndSite">{{ this.$store.state.results.site.name }}<br>
            <small> {{this.$store.state.results.site.address}}</small>
            <hr>
          </h4>
          <h4 >
            <div class="box red"><span class="text-center">{{ labName + ' ' +  translatedFields['disclaimer'] }}</span></div>
          </h4>
          <label class="control-label">
          </label>
          <p v-html="disclaimer_text">
          </p>
          <hr>
          <p-checkbox v-model="model.agreed" name="agreed"
                      v-validate="modelValidations.agreed"
          >{{ translatedFields['i_agree'] }}</p-checkbox>
          <small class="text-danger" v-show="agreed.invalid">
            {{ getError('agreed') }}
          </small>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import axios from 'axios'

  export default {
    data () {
      return {
        skip_security_code: process.env.SKIP_SECURITY_CODE,
        labName: process.env.LAB_NAME,
        showAddressAndSite: process.env.SHOW_ADDRESS_DISCLAIMER,
        translatedFields: '',
        fields_en: {
          i_agree: 'I agree',
          disclaimer: 'Disclaimer'
        },
        model: {
          agreed: false
        },
        text: '',
        modelValidations: {
          agreed: {
            required: true
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validate () {
        if (!this.model.agreed) {
          this.$validator.errors.add({field: 'agreed', msg: 'Please accept!'})
          let field = this.$validator._resolveField('agreed')
          field.setFlags({invalid: true})
          return false
        } else {
          if (this.skip_security_code) {
            await this.getResults()
          } else {
            if (!(process.env.SECURITY_CODE_BY_TEXT && process.env.SECURITY_CODE_BY_EMAIL)) {
              let sendMethod
              if (process.env.SECURITY_CODE_BY_TEXT) {
                this.$store.state.results.user['sendTo'] = this.$store.state.results.user.phone
                sendMethod = 'phone'
              } else {
                this.$store.state.results.user['sendTo'] = this.$store.state.results.user.email
                sendMethod = 'email'
              }
              let form = {
                code: this.$store.state.results.user.code,
                send_method: sendMethod
              }
              await this.generateSecurityCode(form)
            }
          }
          return this.$validator.validateAll()
        }
      },
      async generateSecurityCode (form) {
        await axios.post(process.env.SERVER_URI + '/generate/confirmation_code', form).then((response) => {
          if (response.data === false) {
            this.$validator.errors.add({field: 'agreed', msg: 'Server issues!'})
            let field = this.$validator._resolveField('agreed')
            field.setFlags({invalid: true})
            //eslint-disable-next-line
            reject(new Error('Server issues!'))
          }
        }).catch(() => {
          this.$validator.errors.add({field: 'agreed', msg: 'Server issues!'})
          let field = this.$validator._resolveField('agreed')
          field.setFlags({invalid: true})
          //eslint-disable-next-line
          reject(new Error('Server issues!'))
        })
      },
      async getResults () {
        await axios.get(process.env.SERVER_URI + '/get/results/' + this.$store.state.results.site.site_code + '/' + this.$store.state.results.user.code).then((response) => {
          if (response.data === false) {
            this.$validator.errors.add({field: 'agreed', msg: 'Something went wrong!'})
            let field = this.$validator._resolveField('agreed')
            field.setFlags({invalid: true})
            // eslint-disable-next-line
            reject(new Error('Something went wrong!'))
          } else {
            this.$store.state.results.user.result = response.data
            this.$emit('result', response.data)
          }
        }).catch(() => {
          this.$validator.errors.add({field: 'agreed', msg: 'Server issues!'})
          let field = this.$validator._resolveField('agreed')
          field.setFlags({invalid: true})
          //eslint-disable-next-line
          reject(new Error('Server issues!'))
        })
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      }
    },
    computed: {
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      disclaimer_text () {
        if (this.language === 'ES' && this.$store.state.results.site.disclaimer_es) {
          return this.$store.state.results.site.disclaimer_es
        } else {
          if (this.language === 'ZH' && this.$store.state.results.site.disclaimer_zh) {
            return this.$store.state.results.site.disclaimer_zh
          } else {
            if (this.language === 'EN' && this.$store.state.results.site.disclaimer) {
              return this.$store.state.results.site.disclaimer
            }
          }
        }
      },
      ...mapFields(['agreed'])
    },
    watch: {
      language () {
        this.checkLanguage()
      }
    }
  }
</script>

<style scoped>
  span{
    position: relative;
    padding-left: 25px;
    font-size: 1.25em;
    font-weight: 400;
    line-height: 1.4em;
  }
  /* span:before{
    position: absolute;
    content: "";
    width: 18px;
    height: 18px;
    margin: 10px 10px 10px 0px;
    left: 0;
    background-color:red;
    border: 1px solid black;
  } */
  .box {
    margin-top: 20px;
    text-align: center;
  }

/* @media screen and (max-width: 550px) {
  h5 {
     font-size: 18px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/Wizard/DisclaimerStep.vue